import { NgModule } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogService } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';
import { DatePickerModule } from 'primeng/datepicker';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SplitterModule } from 'primeng/splitter';
import { TabsModule } from 'primeng/tabs';
import { SliderModule } from 'primeng/slider';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { HitlistPaginatorComponent } from './hitlist-paginator/hitlist-paginator.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { TreeModule } from 'primeng/tree';

const primeNgModules = [
    InputTextModule,
    CheckboxModule,
    SelectButtonModule,
    TooltipModule,
    RippleModule,
    ButtonModule,
    DatePickerModule,
    PopoverModule,
    ScrollPanelModule,
    AutoCompleteModule,
    TableModule,
    ToastModule,
    ProgressSpinnerModule,
    SelectModule,
    ToggleSwitchModule,
    SplitterModule,
    TabsModule,
    SliderModule,
    MenuModule,
    ContextMenuModule,
    TreeModule,
    MenubarModule,
];

const primeNgServices = [DialogService];

@NgModule({
    declarations: [HitlistPaginatorComponent, BreadcrumbsComponent],
    imports: [...primeNgModules, NgxChartsModule],
    exports: [...primeNgModules, NgxChartsModule, HitlistPaginatorComponent, BreadcrumbsComponent],
    providers: [...primeNgServices],
})
export class UiLibraryModule {}
